export const transportCompaniesColumns = [
  { field: 'businessName', header: 'Nombre de compañía', sortable: true, filter: true },
  { field: 'eur', header: 'EUR', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const stationsColumns = [
  { field: 'id', header: 'Id de estación', sortable: true, filter: true },
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const operatorsColumns = [
  {
    field: 'technologicalOperatorId',
    header: 'Id de operador tecnológico',
    sortable: true,
    filter: true
  },
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'address', header: 'Dirección', sortable: true, filter: true },
  { field: 'phone', header: 'Teléfono', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const locationsColumns = [
  { field: 'locationId', header: 'Locación', sortable: true, filter: true },
  { field: 'stationName', header: 'Estación', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const pcModuleColumns = [
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'pcModuleId', header: 'Id de Módulo PC', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const economicNumberColumns = [
  { field: 'economicNumber', header: 'Número económico', sortable: true, filter: true },
  { field: 'routeName', header: 'Ruta', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const pointOfSaleColumns = [
  { field: 'pointOfSaleId', header: 'Id de punto de venta', sortable: true, filter: true },
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const projectsColumns = [
  { field: 'id', header: 'Id de proyecto', sortable: true, filter: true },
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const routesColumns = [

  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'routeNumber', header: 'Número de ruta', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const deviceTypesColumns = [
  { field: 'number', header: 'Número', sortable: true, filter: true },
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'status', header: 'Estatus', sortable: true },
];

export const samTypesColumns = [
  { field: 'Code', header: 'Código', sortable: true, filter: true },
  { field: 'Name', header: 'Nombre', sortable: true, filter: true },
  { field: 'KeyNumbers', header: 'Numero de Llave', sortable: true },
];

export const profileCardColumns = [
  { field: 'name', header: 'Nombre', sortable: true, filter: true },
  { field: 'number', header: 'Número', sortable: true, filter: true },
];

export const cardMappingColumns = [
  { field: 'version', header: 'Versión', sortable: true, filter: true },
  { field: 'releaseDate', header: 'Fecha de lanzamiento', sortable: true, filter: true },
  { field: 'isActive', header: 'Estado', sortable: true },
];